module.exports = __webpack_public_path__ + "img/copy_copy.3b4afc04.svg";